module.exports = __webpack_public_path__ + "static/img/xmithie.b10b5f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/xmithie.jpg
// module id = FSic
// module chunks = 35